/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2022-11-14 11:27:50
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-15 16:24:41
 */
import config from './config/login'
import axios from '@/utils/request'
export const login = params => axios.post(config.login, params) // 登录
export const getMenu = params => axios.post(config.getMenu, params) //获取全部菜单
export const tencentUpload = params => axios.post(config.tencentUpload, params) //腾讯上传
export const userIsSuper = params => axios.post(config.userIsSuper, params) //获取是否为超管
